<template>
    <section class="group-detail" aria-labelledby="group-detail-title">
        <header class="group-detail__header">
            <div class="group-detail__title">
                <h2 id="group-detail-title">{{ item.name }}</h2>
                <span class="text-muted">Сотрудников: {{ members.length }}</span>
            </div>
            <div class="group-detail__actions">
                <b-button size="sm" variant="outline-secondary" :disabled="busy" @click="$emit('rename')">Переименовать</b-button>
                <b-button v-b-tooltip.hover size="sm" variant="outline-danger" title="Удалить группу" aria-label="Удалить группу" :disabled="busy" @click="$emit('delete')"><i class="fas fa-trash-alt" aria-hidden="true"/></b-button>
            </div>
        </header>
        <div class="group-detail__roles">
            <h3>По роли на объекте
                <b-button v-b-tooltip.hover.focus variant="link" class="group-detail__help" title="При добавлении группы в мастере или карточке подставится команда конкретного объекта. «Имеющие доступ» — сотрудники из одноимённого поля команды, без автоматического добавления всех администраторов компании." aria-label="Как подставляются роли объекта"><i class="far fa-question-circle" aria-hidden="true"/></b-button>
            </h3>
            <div v-for="role in roles" :key="role.key" class="group-detail__role">
                <b-form-checkbox :key="'role-' + busy" :checked="!!roleValue(role.key)" :disabled="busy" @change="setRole(role.key, $event)">{{ role.title }}</b-form-checkbox>
                <b-form-checkbox v-if="roleValue(role.key)" :key="'admin-' + busy" :checked="!!roleValue(role.key).isAdmin" :disabled="busy" :aria-label="'Администратор: ' + role.title" @change="setRoleAdmin(role.key, $event)">Администратор</b-form-checkbox>
            </div>
            <small class="text-muted">Состав подставляется при добавлении группы. Уже созданные Telegram-группы не меняются.</small>
        </div>
        <div class="group-detail__toolbar">
            <h3>Сотрудники</h3>
            <b-button size="sm" variant="success" :disabled="busy" @click="$emit('add')"><i class="fas fa-plus mr-1" aria-hidden="true"/>Добавить сотрудников</b-button>
        </div>
        <b-form-input v-if="members.length" v-model="search" type="search" size="sm" class="group-detail__search" aria-label="Поиск участника группы" placeholder="Найти участника"/>
        <div v-if="!members.length" class="group-detail__empty">Конкретные сотрудники пока не добавлены. Можно выбрать людей, роли объекта или совместить оба варианта.</div>
        <p v-else-if="!filteredMembers.length" class="group-detail__empty">Участник не найден.</p>
        <ul v-else class="group-detail__members">
            <li v-for="user in filteredMembers" :key="user.user_id" class="group-detail__member">
                <EmployeeLink :user="user" name-order="last-first" class="group-detail__person"/>
                <div class="group-detail__member-actions">
                    <b-form-checkbox :key="'admin-' + busy" :checked="user.telegram_admin_required || !!(user.ChatGroups && user.ChatGroups.IsAdmin)" :disabled="busy || user.telegram_admin_required" :aria-label="'Администратор: ' + personName(user)" @change="setMemberAdmin(user, $event)">Администратор</b-form-checkbox>
                    <b-button v-b-tooltip.hover size="sm" variant="link" class="text-muted" title="Убрать из группы" :aria-label="'Убрать из группы: ' + personName(user)" :disabled="busy" @click="$emit('remove', user)"><i class="fas fa-times" aria-hidden="true"/></b-button>
                </div>
            </li>
        </ul>
    </section>
</template>
<script>
import EmployeeLink from '@/components/EmployeeLink.vue';
import {objectGroupRoles, personName, matchesPerson} from '@/utils/userGroupParticipants';
export default {
    name: 'GroupCard', components: {EmployeeLink},
    props: {item: {type: Object, required: true}, busy: Boolean},
    data: () => ({search: '', roles: objectGroupRoles}),
    computed: {
        members() { return this.item.users || []; },
        filteredMembers() { return this.members.filter(user => matchesPerson(user, this.search)); }
    },
    methods: {
        personName,
        setMemberAdmin(user, isAdmin) { if (!this.busy && !user.telegram_admin_required) this.$emit('admin', {user_id: user.user_id, isAdmin}); },
        roleValue(role) { return (this.item.object_roles || []).find(item => item.role === role); },
        setRole(role, selected) {
            const roles = (this.item.object_roles || []).filter(item => item.role !== role);
            if (selected) roles.push({role, isAdmin: role === 'curator'});
            this.$emit('roles', roles);
        },
        setRoleAdmin(role, isAdmin) { this.$emit('roles', (this.item.object_roles || []).map(item => item.role === role ? {...item, isAdmin} : {...item})); }
    }
};
</script>
<style scoped>
.group-detail {padding: 16px; min-width: 0;}
.group-detail__header, .group-detail__toolbar, .group-detail__role, .group-detail__member {display: flex; align-items: center; justify-content: space-between; gap: 12px;}
.group-detail__header {align-items: flex-start; margin-bottom: 16px;}
.group-detail__title {min-width: 0;}
.group-detail h2 {font-size: 18px; line-height: 1.4; overflow-wrap: anywhere; margin: 0 0 4px;}
.group-detail h3 {font-size: 14px; font-weight: 600; margin: 0;}
.group-detail__actions, .group-detail__member-actions {display: flex; align-items: center; gap: 8px; flex-shrink: 0;}
.group-detail__roles {padding: 12px; background: #f8f9fa; border-radius: 6px; margin-bottom: 20px;}
.group-detail__roles h3 {margin-bottom: 6px;}
.group-detail__role {min-height: 36px; flex-wrap: wrap; gap: 4px 12px; padding: 4px 0;}
.group-detail__roles small {display: block; margin-top: 6px;}
.group-detail__help {padding: 0 4px; color: #6c757d;}
.group-detail__toolbar {flex-wrap: wrap; margin-bottom: 12px;}
.group-detail__search {max-width: 360px; margin-bottom: 8px;}
.group-detail__members {list-style: none; padding: 0; margin: 0;}
.group-detail__member {padding: 9px 0; border-bottom: 1px solid #edf0f2;}
.group-detail__member:last-child {border-bottom: 0;}
.group-detail__person {min-width: 0; overflow-wrap: anywhere;}
.group-detail__person >>> .employee-link {white-space: normal; text-align: left;}
.group-detail__empty {padding: 20px 0; margin: 0; color: #6c757d; max-width: 500px;}
@media (max-width: 767px) {
    .group-detail {padding: 12px;}
    .group-detail__header {flex-wrap: wrap;}
    .group-detail__member {flex-wrap: wrap; gap: 6px;}
    .group-detail__person {flex-basis: 100%;}
    .group-detail__member-actions {width: 100%; justify-content: space-between; padding-left: 30px;}
    .group-detail__search {max-width: none; font-size: 16px;}
}
</style>
